import { Typography, Box, Container } from '@mui/material';
import { useState, useEffect } from 'react';

import { Jobseeker } from '@libs/models';
import { useJobseekerUserQuery } from '@carcareers/store';
import { useAuth } from '@carcareers/hooks';
import { Breadcrumbs, SkeletonForm, DeleteAccountAction, UserPreferences } from '@carcareers/components';

export const JobseekerSettings = () => {
  const [jobseeker, setJobseeker] = useState<Jobseeker>();

  const { user } = useAuth();
  const { data: jobseekerData, isLoading } = useJobseekerUserQuery(user?.id ?? 0, {
    skip: !user?.id,
  });

  useEffect(() => {
    if (jobseekerData) {
      setJobseeker(jobseekerData);
    }
  }, [jobseekerData]);

  if (isLoading || !jobseeker) {
    return (
      <>
        <Breadcrumbs />
        <Box sx={{ px: 4, py: 2 }}>
          <SkeletonForm />
        </Box>
      </>
    );
  }

  return (
    <Container maxWidth="lg">
      <Breadcrumbs idReplacement={`${jobseeker?.user?.firstName} ${jobseeker?.user?.lastName}`} />
      <Box sx={{ mt: 3 }}>
        <UserPreferences />
      </Box>
      <Box
        sx={{
          px: 4,
          py: 2,
          display: 'flex',
          gap: 2,
          flexDirection: 'column',
          border: '1px solid',
          borderColor: 'error.light',
          borderRadius: 2,
          mt: 3,
        }}
      >
        <Typography variant="h5" sx={{ color: 'error.light' }}>
          Danger Zone
        </Typography>
        <DeleteAccountAction type="jobseeker" />
      </Box>
    </Container>
  );
};

export default JobseekerSettings;
